export const tableEntity = (t) => [
  { id: "entity_name", label: t('common:labels.name') },
  { id: "entity_type", label: t('common:labels.type'), type: "type-entity" },
  { id: "status", label: t('common:labels.status'), type: "status" },
  { id: "maturity_level", label: t('gap-analysis:table.maturityLevel'), type: "maturity-level" },
  { id: "actions", type: "actions", label: "" },
];
